<template>
  <div class="content">
    <div class="container-fluid h-100">
      <div class="row h-100">
        <div class="col h-100">
          <card-item>
            <div class="d-flex justify-content-end">
              <button class="btn btn-danger btn-sm" @click="volver">
                Volver
              </button>
            </div>
          </card-item>
          <card-item
            class="striped-tabled-with-hover"
            body-classes="table-full-width table-responsive"
          >
            <template slot="header">
              <div class="d-flex justify-content-between">
                <div>
                  <h4 class="card-title">
                    Facturas y notas de credito del cliente: {{ nombreCliente }}
                  </h4>
                  <p class="card-category">Listado</p>
                </div>
                <div class="button-group">
                  <button @click="exportarExcel" class="btn btn-primary">
                    Exportar Excel
                  </button>
                </div>
              </div>
            </template>

            <div class="container-fluid h-100">
              <div class="row">
                <div class="col">
                  <div class="form-group">
                    <div class="row align-items-center">
                      <div class="col-12 col-md-9 form-group">
                        <label for="quickFilter" class="label"
                          >Filtro rapido</label
                        >
                        <input
                          type="text"
                          class="form-control"
                          id="quickFilter"
                          v-model="quickFilter"
                        />
                      </div>
                      <div class="col-12 col-md-3 form-group">
                        <label for="fechaDesde" class="label">Desde:</label>
                        <input
                          type="date"
                          v-model="fechaDesde"
                          class="form-control"
                          id="fechaDesde"
                        />
                      </div>
                    </div>
                  </div>
                </div>
              </div>
              <div class="row" style="height: 100%">
                <div class="col" style="position: relative; height: 100%">
                  <ag-grid-vue
                    style="width: 100%; height: 60vh"
                    class="ag-theme-alpine"
                    @gridReady="onGridReady"
                    :columnDefs="columnDefs"
                    :defaultColDef="defaultColDef"
                    :gridOptions="gridOptions"
                    :rowData="facturasYNC"
                    :excelStyles="excelStyles"
                    :getContextMenuItems="getContextMenuItems"
                  >
                  </ag-grid-vue>
                </div>
              </div>
            </div>
          </card-item>
        </div>
      </div>
    </div>
  </div>
</template>
<script>
import { AgGridVue } from "ag-grid-vue";
import { get } from "lodash-es";
import axios from "axios";
import moment from "moment";
import NombreCliente from "../shared/NombreCliente";
import { formatMM } from "../../../lib/utils/accountingJsFns";
import FacturasYNCTableActions from "./FacturasYNCTableActions";

export default {
  name: "FacturasYNotasDeCredito",
  mixins: [NombreCliente],
  components: { AgGridVue },
  beforeMount() {
    this.gridOptions = {
      statusBar: {
        statusPanels: [
          {
            statusPanel: "agTotalAndFilteredRowCountComponent",
            align: "left",
          },
          {
            statusPanel: "agTotalRowCountComponent",
            align: "center",
          },
          { statusPanel: "agFilteredRowCountComponent" },
          { statusPanel: "agSelectedRowCountComponent" },
          { statusPanel: "agAggregationComponent" },
        ],
      },
      enableClipboard: true,
      enableRangeSelection: true,
      suppressCopyRowsToClipboard: false,
    };

    this.excelStyles = [
      {
        id: "header-title",
        font: { bold: true },
        alignment: {
          vertical: "Center",
          horizontal: "Center",
        },
      },
      {
        id: "text-center",
        alignment: {
          vertical: "Center",
          horizontal: "Center",
        },
      },
    ];
  },
  computed: {
    fechaDesdeComputed: {
      get() {
        return moment(this.fechaDesde).format("YYYY-MM-DD");
      },
      set(val) {
        this.fechaDesde = val;
      },
    },
  },
  methods: {
    volver() {
      this.$router.push(`/admin/clientes/`);
    },
    async getData() {
      try {
        const resp = await axios.post("/execute", {
          method: "CLI.GetFacturasYNotasDeCreditoByClienteId",
          parameters: [
            { name: "id_cliente", value: this.$route.params.id_cliente },
            { name: "fechaDesde", value: this.fechaDesde },
          ],
        });
        if (resp.data.ok) {
          this.facturasYNC = get(resp, "data.result[0]", []);
        } else {
          this.$msgBoxOk(resp.message);
        }
        return resp;
      } catch (e) {
        this.$msgBoxOk(e);
      }
    },
    exportarExcel() {
      const fechaHoy = moment().format("DD-MM-YYYY");
      this.gridApi.exportDataAsExcel({
        fileName: `EC_${this.nombreCliente}_al_${fechaHoy}.xlsx`,
        sheetName: `${this.nombreCliente}`,
      });
    },
    onGridReady(params) {
      this.gridApi = params.api;
      this.columnApi = params.columnApi;

      this.gridApi.showLoadingOverlay();
      this.getData().then(() => {
        this.gridApi.hideOverlay();
      });

      this.getNombreCliente(this.$route.params.id_cliente).then((resp) => {
        if (get(resp, "ok", true) === false) {
          this.$msgBoxOk(resp.message);
        }
      });
    },
    getContextMenuItems() {
      return ["copy", "excelExport"];
    },
  },
  data: () => ({
    fechaDesde: null,
    facturasYNC: [],
    excelStyles: null,
    quickFilter: "",
    gridOptions: null,
    gridApi: null,
    columnApi: null,

    defaultColDef: {
      sortable: true,
      resizable: true,
      flex: 1,
      wrapHeaderText: true,
      autoHeaderHeight: true,
      enableCellTextSelection: true,
      ensureDomOrder: true,
    },
    columnDefs: [
      {
        headerName: "Tipo Comprobante",
        headerClass: "header-title",
        cellClass: "text-center",
        minWidth: 140,
        valueGetter: (params) => params.data.TipoComprobante,
      },
      {
        headerName: "Punto Venta",
        headerClass: "header-title",
        cellClass: "text-center",
        maxWidth: 100,
        minWidth: 100,
        valueGetter: (params) => params.data.Ptovta,
      },
      {
        field: "Nº comprobante",
        headerClass: "header-title",
        cellClass: "text-center",
        maxWidth: 140,
        minWidth: 140,
        valueGetter: (params) => params.data.NroComprobante,
      },
      {
        field: "Fecha emision",
        headerClass: "header-title",
        cellClass: "text-center",
        minWidth: 110,
        valueGetter: (params) =>
          moment(params.data.FechaEmision).format("DD-MM-YYYY"),
      },
      {
        flex: 2,
        field: "Nombre cliente",
        headerClass: "header-title",
        cellClass: "text-center",
        minWidth: 200,
        wrapText: true,
        autoHeight: true,
        valueGetter: (params) => params.data.ClienteNombre,
      },
      {
        field: "Neto",
        headerClass: "header-title",
        cellClass: "text-center",
        minWidth: 110,
        valueGetter: (params) => formatMM(params.data.Neto),
      },
      {
        field: "IVA",
        headerClass: "header-title",
        cellClass: "text-center",
        minWidth: 110,
        valueGetter: (params) => formatMM(params.data.IVA),
      },
      {
        field: "Total",
        headerClass: "header-title",
        cellClass: "text-center",
        minWidth: 110,
        valueGetter: (params) => formatMM(params.data.Total),
      },
      {
        headerName: "Fecha vencimiento",
        headerClass: "header-title",
        cellClass: "text-center",
        minWidth: 140,
        valueGetter: (params) =>
          moment(params.data.FechaVencimiento).format("DD-MM-YYYY"),
      },
      {
        headerName: "Descargar PDF",
        headerClass: "header-title",
        cellClass: "text-center",
        minWidth: 140,
        cellRendererFramework: FacturasYNCTableActions,
      },
    ],
  }),
  watch: {
    quickFilter(val) {
      this.gridApi.setQuickFilter(val);
    },
    fechaDesde(newVal, oldVal) {
      if (newVal !== oldVal) {
        this.getData();
      }
    },
  },
};
</script>
<style></style>
